import {
    SYNC_SUBSCRIPTION,
    UPDATE_SUBSCRIPTION_SUCCESS,
    SYNC_SUBSCRIPTION_SUCCESS,
    CANCEL_SUBSCRIPTION_SUCCESS,
    REACTIVATE_SUBSCRIPTION_SUCCESS,
    INVITE_USERS_SUCCESS,
    UPDATE_SUBSCRIPTION_ERROR,
    REACTIVATE_SUBSCRIPTION_ERROR,
    CANCEL_SUBSCRIPTION_ERROR,
    SYNC_SUBSCRIPTION_ERROR,
    CREATE_SUBSCRIPTION_ERROR,
    INVITE_USERS_ERROR,
    ADD_USER_ERROR,
} from '../actions/subscriptions';
import {
    CREATE_USER_ERROR,
    DISMISS_USER_ALERT_ERROR,
} from '../actions/users';
import {ACCEPT_INVITATION_ERROR} from '../actions/invitations';
import { CLEAR_MESSAGE, CLEAR_MESSAGES } from '../actions/messages';
import { 
    INVITE_DOMAIN_SUCCESS,
    REMOVE_DOMAIN_SUCCESS, 
    INVITE_DOMAIN_ERROR, 
    REMOVE_DOMAIN_ERROR,
    ACCEPT_USER_DOMAIN_INVITATIONS_ERROR} from '../actions/domains';

const MESSAGES = {
    // Unused, in favor of subscription.greeting flag (see BP-28)
    CREATED: 'subscription.messages.created',
    CANCELLED: 'subscription.messages.cancelled',
    REACTIVATED: 'subscription.messages.reactivated',
    UPDATED: 'subscription.messages.updated',
    PAYMENT_INFO_UPDATED: 'subscription.messages.paymentInfoUpdated',
    PAYMENT_INFO_UPDATED_WITH_TRIALING_STATUS: 'subscription.messages.paymentInfoUpdated.withTrialing',
    INVITES_SENT: 'subscription.invitations.info.invitesSent',
    NO_INVITES_SENT: 'subscription.invitations.info.noInvitesSent',
    API_ERROR: 'error.snacks.apiError',
    DOMAIN_REGISTERED: 'subscription.domains.snack.success.domainRegistered',
    INVITING_DOMAIN_ERROR: 'subscription.domains.snack.error.inviting.error',
    DOMAIN_REMOVED: 'subscription.domains.snack.success.domainRemoved',
    REMOVING_DOMAIN_ERROR: 'subscription.domains.snack.error.removing.error',
};

export const TYPES = {
    SNACK: 'snack',
    DIALOG: 'dialog',
}

export const DIALOG_TYPES = {
    SUBSCRIPTION_REACTIVATION_SUCCESS: "REACTIVATE_SUBSCRIPTION_SUCCESS",
    SUBSCRIPTION_UPDATE_SUCCESS: "UPDATE_SUBSCRIPTION_SUCCESS",
    SUBSCRIPTION_SYNC_SUCCESS: "UPDATE_SYNC_SUCCESS",
}

const messages = (state = [], action) => {
    switch (action.type) {
        case SYNC_SUBSCRIPTION:
        case CLEAR_MESSAGES:
            return [];
        case CLEAR_MESSAGE:
            let newState = state.slice()
            newState.splice(action.id,1)
            return newState
        case CANCEL_SUBSCRIPTION_SUCCESS:
            return state.concat([{type:TYPES.SNACK, content:MESSAGES.CANCELLED, error: false}])
        case REACTIVATE_SUBSCRIPTION_SUCCESS:
            return state.concat(
                [{
                    type:TYPES.DIALOG, 
                    dialogType: DIALOG_TYPES.SUBSCRIPTION_REACTIVATION_SUCCESS, 
                    subscription: action.subscription, 
                    content:MESSAGES.REACTIVATED, 
                    error: false
                }]
            )
        case UPDATE_SUBSCRIPTION_SUCCESS:
            return state.concat(
                [{
                    type:TYPES.DIALOG, 
                    dialogType: DIALOG_TYPES.SUBSCRIPTION_UPDATE_SUCCESS, 
                    subscription: action.subscription, 
                    content:MESSAGES.UPDATED, 
                    error: false
                }])
        case SYNC_SUBSCRIPTION_SUCCESS:
            return state.concat(
                [{
                    type:TYPES.DIALOG, 
                    dialogType: DIALOG_TYPES.SUBSCRIPTION_SYNC_SUCCESS, 
                    subscription: action.subscription, 
                    content:action.subscription.status ==='trialing' 
                        ? MESSAGES.PAYMENT_INFO_UPDATED_WITH_TRIALING_STATUS
                        : MESSAGES.PAYMENT_INFO_UPDATED,
                    error: false
                }])
        case INVITE_USERS_SUCCESS:
            return state.concat(
                action.invitations.length > 0 
                ? [{type:TYPES.SNACK, content:MESSAGES.INVITES_SENT, error: false}] 
                : [{type:TYPES.SNACK, content:MESSAGES.NO_INVITES_SENT, error: false}])
        case INVITE_DOMAIN_SUCCESS:
            return state.concat([{type:TYPES.SNACK, content:MESSAGES.DOMAIN_REGISTERED, error: false, value: action.domain.domain}])
        case REMOVE_DOMAIN_SUCCESS:
            return state.concat([{type:TYPES.SNACK, content:MESSAGES.DOMAIN_REMOVED, error: false, value: action.domainName}])
        case UPDATE_SUBSCRIPTION_ERROR:
        case REACTIVATE_SUBSCRIPTION_ERROR:
        case CANCEL_SUBSCRIPTION_ERROR:
        case SYNC_SUBSCRIPTION_ERROR:
            return state.concat({type:TYPES.SNACK, content:MESSAGES.API_ERROR, error: true, errors: action.error.errors});
        case CREATE_USER_ERROR:
        case CREATE_SUBSCRIPTION_ERROR:
        case ACCEPT_INVITATION_ERROR:
        case INVITE_USERS_ERROR:
        case ADD_USER_ERROR:
        case DISMISS_USER_ALERT_ERROR:
        case ACCEPT_USER_DOMAIN_INVITATIONS_ERROR:
            if (action.error.errors) {
                return state.concat([{type:TYPES.SNACK, content:MESSAGES.API_ERROR, error: true, errors: action.error.errors}])
            } else {
                return state.concat([{type:TYPES.SNACK, content:MESSAGES.API_ERROR, error: true, errors: [action.error]}])
            }
        case INVITE_DOMAIN_ERROR:
            return state.concat({type:TYPES.SNACK, content:MESSAGES.INVITING_DOMAIN_ERROR, error: true, value: action.domainName });
        case REMOVE_DOMAIN_ERROR:
            return state.concat({type:TYPES.SNACK, content:MESSAGES.REMOVING_DOMAIN_ERROR, error: true, value: action.domainName });
        default:
            return state;
    }
}

export default messages;


// WEBPACK FOOTER //
// ./src/reducers/messages.js